import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "converter-container"
};
const _hoisted_2 = {
  class: "converter-card"
};
const _hoisted_3 = {
  class: "tabs"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  key: 0,
  class: "tab-content"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<label for=\"yaml-upload\" class=\"upload-label\"><div class=\"upload-icon\"><svg viewBox=\"0 0 24 24\" width=\"48\" height=\"48\"><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" fill=\"currentColor\"></path></svg></div><p class=\"upload-text\">拖放YAML文件到这里或点击上传</p><p class=\"upload-hint\">支持 .yaml 和 .yml 格式</p></label>", 1);
const _hoisted_7 = {
  class: "input-area"
};
const _hoisted_8 = {
  key: 0,
  class: "result-section"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "JSON结果", -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  fill: "currentColor"
})], -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
  fill: "currentColor"
})], -1);
const _hoisted_12 = {
  class: "json-preview"
};
const _hoisted_13 = {
  key: 1,
  class: "error-message"
};
const _hoisted_14 = {
  key: 1,
  class: "tab-content"
};
const _hoisted_15 = {
  class: "input-area"
};
const _hoisted_16 = {
  key: 0,
  class: "result-section"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "YAML结果", -1);
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  fill: "currentColor"
})], -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z",
  fill: "currentColor"
})], -1);
const _hoisted_20 = {
  class: "yaml-preview"
};
const _hoisted_21 = {
  key: 1,
  class: "error-message"
};
import { ref, computed, onUnmounted } from 'vue';
import { saveAs } from 'file-saver';
import * as YAML from 'yaml';
import { debounce } from 'lodash-es';
export default {
  __name: 'JsonYaml',
  setup(__props) {
    const activeTab = ref('yamlToJson');
    const yamlInput = ref('');
    const jsonInput = ref('');
    const jsonResult = ref(null);
    const yamlResult = ref('');
    const conversionError = ref('');
    const isDragging = ref(false);
    const notification = ref({
      show: false,
      message: '',
      type: 'success'
    });

    // 格式化显示的JSON
    const formattedJson = computed(() => {
      return JSON.stringify(jsonResult.value, null, 2);
    });

    // 检查JSON是否有效
    // const isValidJson = computed(() => {
    //   try {
    //     if (!jsonInput.value.trim()) return false
    //     JSON.parse(jsonInput.value)
    //     return true
    //   } catch {
    //     return false
    //   }
    // })

    // 处理YAML文件上传
    const handleYamlUpload = event => {
      const file = event.target.files[0];
      if (file) {
        processYamlFile(file);
      }
    };

    // 处理拖放
    const dragOver = () => {
      isDragging.value = true;
    };
    const handleDrop = event => {
      isDragging.value = false;
      const file = event.dataTransfer.files[0];
      if (file && (file.name.endsWith('.yaml') || file.name.endsWith('.yml'))) {
        processYamlFile(file);
      } else {
        showNotification('请上传有效的YAML文件 (.yaml 或 .yml)', 'error');
      }
    };

    // 处理YAML文件
    const processYamlFile = file => {
      const reader = new FileReader();
      reader.onload = e => {
        try {
          yamlInput.value = e.target.result;
          convertYamlToJson();
        } catch (error) {
          console.error('Error processing YAML file:', error);
          showNotification('处理YAML文件时出错', 'error');
        }
      };
      reader.onerror = () => {
        showNotification('读取文件时出错', 'error');
      };
      reader.readAsText(file);
    };

    // 将YAML转换为JSON
    const convertYamlToJson = () => {
      try {
        if (!yamlInput.value.trim()) {
          jsonResult.value = null;
          conversionError.value = '';
          return;
        }
        jsonResult.value = YAML.parse(yamlInput.value);
        conversionError.value = '';
      } catch (error) {
        conversionError.value = `YAML解析错误: ${error.message}`;
        jsonResult.value = null;
      }
    };

    // 将JSON转换为YAML
    const convertJsonToYaml = () => {
      try {
        if (!jsonInput.value.trim()) {
          yamlResult.value = '';
          conversionError.value = '';
          return;
        }
        const json = JSON.parse(jsonInput.value);
        yamlResult.value = YAML.stringify(json, {
          indent: 2
        });
        conversionError.value = '';
      } catch (error) {
        conversionError.value = `JSON解析错误: ${error.message}`;
        yamlResult.value = '';
      }
    };

    // 复制结果到剪贴板
    const copyResult = () => {
      const textToCopy = activeTab.value === 'yamlToJson' ? formattedJson.value : yamlResult.value;
      navigator.clipboard.writeText(textToCopy).then(() => showNotification(activeTab.value === 'yamlToJson' ? 'JSON已复制到剪贴板' : 'YAML已复制到剪贴板', 'success')).catch(() => showNotification('复制失败', 'error'));
    };

    // 下载JSON文件
    const downloadJson = () => {
      const blob = new Blob([formattedJson.value], {
        type: 'application/json'
      });
      saveAs(blob, 'data.json');
      showNotification('JSON文件下载开始', 'success');
    };

    // 下载YAML文件
    const downloadYaml = () => {
      const blob = new Blob([yamlResult.value], {
        type: 'text/yaml'
      });
      saveAs(blob, 'data.yaml');
      showNotification('YAML文件下载开始', 'success');
    };

    // 显示通知
    const showNotification = (message, type) => {
      notification.value = {
        show: true,
        message,
        type
      };
      setTimeout(() => {
        notification.value.show = false;
      }, 3000);
    };

    // 防抖转换函数
    const debouncedConvertYamlToJson = debounce(convertYamlToJson, 500);
    const debouncedConvertJsonToYaml = debounce(convertJsonToYaml, 500);

    // 组件卸载时清理
    onUnmounted(() => {
      debouncedConvertYamlToJson.cancel();
      debouncedConvertJsonToYaml.cancel();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        class: _normalizeClass(["tab-button", {
          active: activeTab.value === 'yamlToJson'
        }]),
        onClick: _cache[0] || (_cache[0] = $event => activeTab.value = 'yamlToJson')
      }, " YAML转JSON ", 2), _createElementVNode("button", {
        class: _normalizeClass(["tab-button", {
          active: activeTab.value === 'jsonToYaml'
        }]),
        onClick: _cache[1] || (_cache[1] = $event => activeTab.value = 'jsonToYaml')
      }, " JSON转YAML ", 2)]), _createElementVNode("div", _hoisted_4, [activeTab.value === 'yamlToJson' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        class: "upload-area",
        onDragover: _withModifiers(dragOver, ["prevent"]),
        onDrop: _withModifiers(handleDrop, ["prevent"])
      }, [_createElementVNode("input", {
        type: "file",
        id: "yaml-upload",
        accept: ".yaml,.yml",
        onChange: handleYamlUpload,
        class: "file-input"
      }, null, 32), _hoisted_6], 32), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => yamlInput.value = $event),
        placeholder: "或者直接在此输入YAML内容",
        class: "yaml-textarea",
        onInput: _cache[3] || (_cache[3] = (...args) => _unref(debouncedConvertYamlToJson) && _unref(debouncedConvertYamlToJson)(...args))
      }, null, 544), [[_vModelText, yamlInput.value]])]), jsonResult.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
        class: "result-header"
      }, [_hoisted_9, _createElementVNode("div", {
        class: "action-buttons"
      }, [_createElementVNode("button", {
        onClick: copyResult,
        class: "action-button"
      }, [_hoisted_10, _createTextVNode(" 复制JSON ")]), _createElementVNode("button", {
        onClick: downloadJson,
        class: "action-button"
      }, [_hoisted_11, _createTextVNode(" 下载JSON ")])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("pre", null, _toDisplayString(formattedJson.value), 1)])])) : _createCommentVNode("", true), conversionError.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(conversionError.value), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeTab.value === 'jsonToYaml' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => jsonInput.value = $event),
        placeholder: "请输入有效的JSON数据，例如：{name: '张三', age: 25}",
        class: "json-textarea",
        onInput: _cache[5] || (_cache[5] = (...args) => _unref(debouncedConvertJsonToYaml) && _unref(debouncedConvertJsonToYaml)(...args))
      }, null, 544), [[_vModelText, jsonInput.value]])]), yamlResult.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", {
        class: "result-header"
      }, [_hoisted_17, _createElementVNode("div", {
        class: "action-buttons"
      }, [_createElementVNode("button", {
        onClick: copyResult,
        class: "action-button"
      }, [_hoisted_18, _createTextVNode(" 复制YAML ")]), _createElementVNode("button", {
        onClick: downloadYaml,
        class: "action-button"
      }, [_hoisted_19, _createTextVNode(" 下载YAML ")])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("pre", null, _toDisplayString(yamlResult.value), 1)])])) : _createCommentVNode("", true), conversionError.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(conversionError.value), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), notification.value.show ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["notification", notification.value.type])
      }, _toDisplayString(notification.value.message), 3)) : _createCommentVNode("", true)]);
    };
  }
};